import {  Component, HostListener, OnInit } from '@angular/core';
import { ProcesoReporte } from '../../base/proceso-reporte';
import { AppComponent } from 'src/app/app.component';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Router } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { ReporteService } from 'src/app/services/reporte.service';
import { FormBuilder } from '@angular/forms';
import { Empresa } from 'src/app/models/configuracion/empresa.model';
import { EmpresaService } from 'src/app/services/configuracion/empresa.service';
import { GrupoAcceso } from 'src/app/models/seguridad/grupo_acceso.model';
import { HistorialNotificacion } from 'src/app/models/notificacion/historial_notificacion.model';

interface NotificationChannelDefinition {
    tipo: number;
    label: string;
    backgroundColor: string;
    hoverBackgroundColor: string;
    borderColor: string;
}

interface ChartSelectionEvent {
    element?: {
        index?: number;
        datasetIndex?: number;
    };
}

@Component({
  selector: 'app-graficos',
  templateUrl: './graficos.component.html',
  styleUrls: ['./graficos.component.scss']
})
export class GraficosComponent extends ProcesoReporte implements OnInit {

    private readonly informeNotificacionStorageKey = 'informe_notificacion';

    clienteCabal: number;
    clienteProcard: number;
    extractoEnviadoCabal: number;
    extractoEnviadoProcard: number;
    totalClientes: number;
    datanotificacion: any;
    optionsnoti: any;
    CORREO = HistorialNotificacion.TIPO_CORREO;
    WHATSAPP = HistorialNotificacion.TIPO_WHATSAPP;
    MENSAJE = HistorialNotificacion.TIPO_SMS;
    basicOptionsNoti: any;
    basicDataNoti: any;
    basicData: any;
    basicOptions: any;
    data: any;
    options: any;
    isMobileView: boolean;
    labels: string [];
    cantidadCliente: Record<string,any>[];
    extractosAnuales: Record<string,any>;
    notificacionAnuales: Record<string,any>;
    fromDate: Date ;
    toDate: Date ;
    grupoAcceso: GrupoAcceso;
    permisoAdmin: boolean;
    // PERMISOS INICIO COOPERATIVA
    //modulos
    moduloTarjeta: boolean;
    moduloNotificacion: boolean;
    //permisos
    permisoEnviarExtracto: boolean;
    permisoEnviarCorreo: boolean;
    permisoImportarTarjeta: boolean;
    permisoImportarContacto: boolean;
    //reportes
    informeNotificaciones: boolean;
    informeExtractoEnviado: boolean;
    permisoConsultarExtracto: boolean;
    permisoInformeVerificarCorreos: boolean;
    private readonly notificationChannels: NotificationChannelDefinition[];
    constructor(
        public app: AppComponent, 
        private breadcrumbService: AppBreadcrumbService,
        private router: Router,
        private homeService: HomeService,
        private currencyPipe: CurrencyPipe,
        private messageService: MessageService,
        private reporteService: ReporteService,
        private fb: FormBuilder,
        private empresaService: EmpresaService
    ) {
        super();
        this.breadcrumbService.setItems([ { label: 'Graficos' } ]);
        this.fromDate = new Date();
        this.toDate = new Date();
        this.cantidadCliente = [];
        this.totalClientes = 0;
        this.permisoAdmin = false;
        this.moduloNotificacion = false;
        this.moduloTarjeta = false;
        this.permisoEnviarExtracto = false;
        this.permisoEnviarCorreo = false;
        this.permisoImportarContacto = false;
        this.permisoImportarTarjeta = false;
        this.informeExtractoEnviado = false;
        this.informeNotificaciones = false;
        this.permisoConsultarExtracto = false;
        this.permisoInformeVerificarCorreos = false;
        this.notificationChannels = [
            {
                tipo: this.CORREO,
                label: 'Correo',
                backgroundColor: 'rgb(66, 190, 221)',
                hoverBackgroundColor: 'rgb(19, 161, 221)',
                borderColor: 'rgb(54, 162, 235)'
            },
            {
                tipo: this.MENSAJE,
                label: 'SMS',
                backgroundColor: 'rgb(40, 95, 203)',
                hoverBackgroundColor: 'rgb(27, 74, 164)',
                borderColor: 'rgb(65, 117, 237)'
            },
            {
                tipo: this.WHATSAPP,
                label: 'WhatsApp',
                backgroundColor: 'rgb(1, 168, 86)',
                hoverBackgroundColor: 'rgb(0, 134, 80)',
                borderColor: 'rgb(3, 205, 91)'
            }
        ];
    }

    async createForm() {
        const hoy = new Date();
        this.formGroup = this.fb.group({
            'id_empresa': [this.currentUser.id_empresa],
            'nombre_empresa': [this.currentUser.nombre_empresa],
            'annio':[hoy]
        });
    }
    ngOnInit(): void {
        this.createForm();
        this.verificarSeguridad();
        this.detectDevice();        
        this.buscar();
    }

    async verificarSeguridad() {
        this.grupoAcceso = new GrupoAcceso();
        await this.grupoAcceso.cargarObjeto(this.currentUser.grupo_acceso);
        if ( this.currentUser.grupo_acceso.acceso_total ) { 
            this.moduloNotificacion =               true;
            this.moduloTarjeta =                    true;
            this.permisoEnviarExtracto =            true;
            this.permisoEnviarCorreo =              true;
            this.permisoImportarContacto =          true;
            this.permisoImportarTarjeta =           true;
            this.informeExtractoEnviado =           true;
            this.informeNotificaciones =            true;
            this.permisoConsultarExtracto =         true;
            this.permisoInformeVerificarCorreos =   true;
        } else {
            for (let index = 0; index < this.grupoAcceso.modulos.length; index++) {
                const acceso = this.grupoAcceso.modulos[index];            
                switch (acceso.codigo) {
                    case 'cliente_tarjeta':
                        this.moduloTarjeta = acceso.activo;
                        break;
                    case 'notificacion':
                        this.moduloNotificacion = acceso.activo;
                        break;
                    default:
                        break;
                }
            }
            for (let index = 0; index < this.grupoAcceso.permisos.length; index++) {
                const permiso = this.grupoAcceso.permisos[index];            
                switch (permiso.codigo) {
                    case "enviar_extracto":
                        this.permisoEnviarExtracto = permiso.activo;
                        break;
                    case "importar_tarjeta":
                        this.permisoImportarTarjeta = permiso.activo;
                        break;
                    case "enviar_notificacion_correo":
                        this.permisoEnviarCorreo = permiso.activo;
                        break;
                    case "importar_contacto":
                        this.permisoImportarContacto = permiso.activo;
                        break;
                    case "consulta_extractos":
                        this.permisoConsultarExtracto = permiso.activo;
                        break;
                    default:
                        break;
                }
                
            }
            for (let index = 0; index <  this.grupoAcceso.reportes.length; index++) {
                const reporte = this.grupoAcceso.reportes[index];                
                switch (reporte?.codigo) {
                    case 'informe_extracto_enviado':
                        this.informeExtractoEnviado = reporte.activo;
                        break;
                    case 'informe_notificacion':
                        this.informeNotificaciones = reporte.activo;
                        break;
                    case 'verificacion_correos':
                        this.permisoInformeVerificarCorreos = reporte.activo;
                        break;
                    default:
                        break;
                }
            }
        }        
    }
    detectDevice(): void {
        const userAgent = window.navigator.userAgent.toLowerCase();
        this.isMobileView = userAgent.includes('mobile') || userAgent.includes('tablet');
    }
    
    @HostListener('window:resize', ['$event'])
    onWindowResize(event: any): void {
        this.detectDevice();
    }

    async buscar() {
        this.grupoAcceso = new GrupoAcceso();
        await this.grupoAcceso.cargarObjeto(this.currentUser.grupo_acceso);
        if ( this.currentUser.superusuario === true ) {
            this.permisoAdmin = true;
        }
        this.cantidadCliente = [];
        await this.cargarCantidades();
        await this.grafico();
    }

   /** Funciones para vista cooperativa */
    async onAccesoDirecto( ruta: string ) {
        this.router.navigate([this.prefixPage, 'cliente_tarjeta', ...ruta.split("/")]);
    }

    async onAccesoDirectoNotificacion( ruta: string ) {
        this.router.navigate([this.prefixPage, 'notificacion', ...ruta.split("/")]);
    }

    async onNotificationDonutSelect(event: ChartSelectionEvent) {
        const selectedIndex = Number(event.element?.index);
        const channel = this.notificationChannels[selectedIndex];

        if (!channel) {
            return;
        }

        await this.openNotificationReport(channel.tipo);
    }

    async onNotificationBarSelect(event: ChartSelectionEvent) {
        const datasetIndex = Number(event.element?.datasetIndex);
        const channel = this.notificationChannels[datasetIndex];

        if (!channel) {
            return;
        }

        await this.openNotificationReport(channel.tipo);
    }

    async grafico(){
        await this.totalAnhoExtracto();
        await this.notificacionAnual();
        await this.extractoGrafico();
        await this.clienteDona();
        await this.notificacionDona();
        await this.notificacionBarra();
    }
    
    async onEmpresa() {
        try {
            const value = this.formGroup.value;
            let objeto = null;
            if ( value.id_empresa ) {
                const res = await this.empresaService.get( value.id_empresa );
                if ( res.ok ) {
                    objeto = res.resp;
                } else {
                    this.messageService.add({severity: 'error', summary: res.msg, detail: res.resp});
                }
            }
            await this.setEmpresa(objeto);
        } catch (error: any) {
            this.messageService.add(this.objSession);
            setTimeout( () => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }

    async onListaEmpresa() {
        await super.onLista( this.empresaService, Empresa, Empresa.NOMBRE_PLURAL );
    }

    async cerrarOnLista( obj?: Record<string, any> ): Promise<void> {
        await super.cerrarOnLista( obj );
        if ( this.objClassOnLista === Empresa && obj ) {
            await this.setEmpresa(obj);
        }
        this.objClassOnLista = null;
    }


    async setEmpresa( obj: Record<string, any> ) {
        this.formGroup.get('id_empresa').setValue(obj?.id ? obj.id : null);
        this.formGroup.get('nombre_empresa').setValue(obj?.nombre ? obj.nombre : null);
        await this.buscar();
    }
    
    generateLabels(mesActual: number): string[] {
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const labels: string[] = [];
        
        for (let i = 1; i <= mesActual; i++) {
            labels.push(meses[i - 1]);
        }

        return labels;
    }


    
    async cargarCantidades() {
        try {
            const filtros = {
                id_empresa: this.formGroup.value.id_empresa,
                enviado: true,
                annio: this.formGroup.value.annio
            }  
            const res = await this.homeService.montoClienteExtracto(filtros);             
            if ( res.ok ) {
                const obj = res.resp;
                for (let index = 0; index < obj.length; index++) {
                    const cantidad = obj[index];   
                    this.cantidadCliente.push( {
                        clienteCabal: Number(cantidad[0].clientes_cabal), 
                        clienteProcard: Number(cantidad[0].clientes_procard),
                        extractoEnviadoCabal: Number(cantidad[0].extractos_enviados_cabal),
                        extractoEnviadoProcard: Number(cantidad[0].extractos_enviados_procard),
                    });                        
                    if ( index < obj.length ) {
                        this.clienteCabal = cantidad[0].clientes_cabal;
                        this.clienteProcard = cantidad[0].clientes_procard;
                        this.extractoEnviadoCabal = cantidad[0].extractos_enviados_cabal;
                        this.extractoEnviadoProcard = cantidad[0].extractos_enviados_procard;
                    }
                }       
                this.totalClientes = Number(this.clienteCabal) + Number(this.clienteProcard);
                
            }                        
        } catch (error) {            
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
    }

    async clienteDona() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const totalClienteCabal = this.cantidadCliente.reduce((total, cliente) => {
            return total + parseInt(cliente.clienteCabal);
        }, 0);        
        const totalClienteProcard = this.cantidadCliente.reduce((total, cliente) => {
            return total + parseInt(cliente.clienteProcard);
        }, 0);
        const totalClientes = totalClienteCabal +  totalClienteProcard;
        const porcentajeCabal = Math.round((totalClienteCabal / totalClientes) * 100);
        const porcentajeProcard = Math.round((totalClienteProcard / totalClientes) * 100);
        this.data = {
            labels: ['Cabal', 'Procard'],
            datasets: [
                {
                    data: [porcentajeCabal,porcentajeProcard],
                    backgroundColor: ['rgb(40, 95, 203)', 'rgb(1, 168, 86)'],
                    hoverBackgroundColor: ['#1350b2', '#0fad6b'],
                    borderColor: ['rgb(65, 117, 237)', 'rgb(3, 205, 91)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)'],
                }
            ]
        };
        this.options = {
            
            plugins: {
                datalabels: {
                    formatter: (value: any, ctx: any) => {
                        return `${value}%`; 
                    },
                    color: '#FFFFFF',
                    font: {
                        size: 14,
                        weight: 'bold'
                    },
                    anchor: 'end', 
                    align: 'start'
                },
                legend: {
                    labels: {
                        position: 'left',
                        color: '#000000', 
                        usePointStyle: true,
                        font: {
                            weight: 'bold',
                            size: 14,
                        }
                    }
                },
            }
        };
    
    }

    async onDateSelect(event: Date) { 
        this.cantidadCliente = [];     
        await this.cargarCantidades()  
        await this.grafico();
    }
    async totalAnhoExtracto() {
        try {
            const resp = await this.homeService.extractoAnual({ id_empresa: this.formGroup.value.id_empresa, annio: this.formGroup.value.annio });
            if (resp.ok) {
                this.extractosAnuales = resp.resp
            }
        } catch (error) {
            this.messageService.add(this.objSession);
            setTimeout(() => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }
    async extractoGrafico() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = getComputedStyle(document.body).getPropertyValue('--text-color') || 'rgba(0, 0, 0, 0.87)';
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        const gridLinesColor = getComputedStyle(document.body).getPropertyValue('--divider-color') || 'rgba(160, 167, 181, .3)';
        const fontFamily = getComputedStyle(document.body).getPropertyValue('--font-family');
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const clientePorMesCabal = [0,0,0,0,0,0,0,0,0,0,0,0];
        const clientePorMesProcard = [0,0,0,0,0,0,0,0,0,0,0,0];
        const fechaActual = new Date();
        const dateForm = new Date(this.formGroup.value.annio)
        const annoSeleccionado = dateForm.getFullYear(); // Año seleccionado
        const annoActual = fechaActual.getFullYear();
        
        let mesActual;
        if (annoSeleccionado < annoActual) {
            mesActual = 12;
        } else if (annoSeleccionado === annoActual) {
            mesActual = fechaActual.getMonth() + 1;
        } else {
            mesActual = 0; 
        }        
        for (let index = 0; index < mesActual; index++) {
            clientePorMesCabal[index] = this.cantidadCliente[index].clienteCabal;
            clientePorMesProcard[index] = this.cantidadCliente[index].clienteProcard;
        }        
        
        const procesadoraCabal = 1;
        const procesadoraProcard = 2;
        let totalextractoCabal = [];
        let totalextractoProcard = [];
        const extractoCabal = this.extractosAnuales.filter(extracto => extracto.procesadora === procesadoraCabal );
        const extractoProcard = this.extractosAnuales.filter(extracto => extracto.procesadora === procesadoraProcard );
        // console.log(extractoCabal);        
        meses.forEach((_, mesIndex) => {
            let totalMesCabal = 0;
            let totalMesProcard = 0;
            totalMesCabal += extractoCabal.reduce((acc, extracto) => {
                return acc + (extracto.mes === mesIndex + 1 ? extracto.enviado : 0);
            }, 0)
            totalMesProcard += extractoProcard?.reduce((acc, extracto) => {return acc + (extracto.mes === mesIndex + 1 ? extracto.enviado : 0) ;}, 0);
            
            totalextractoCabal.push(totalMesCabal);
            totalextractoProcard.push(totalMesProcard);
        })

        const mesesMostrar = [];
        const totalextractoCabalMostrar = [];
        const totalextractoProcardMostrar = [];
    
        for (let i = 0; i < mesActual; i++) {
            mesesMostrar.push(meses[i]);
            totalextractoCabalMostrar.push(totalextractoCabal[i]);
            totalextractoProcardMostrar.push(totalextractoProcard[i]);
        }

        
        this.basicData = {
            labels: mesesMostrar,
            datasets: [
                {
                    yAxisID: 'y1',
                    label: 'Clientes Cabal',
                    data: clientePorMesCabal,
                    borderColor: ['rgb(40, 95, 203)'],
                    backgroundColor: ['#a5c2f7'],
                    borderWidth: 2,
                    fill: true,
                    tension: 0.4,
                    // barThickness: 40, 
                },
                {
                    yAxisID: 'y1',
                    label: 'Extractos Enviados Cabal',
                    data: totalextractoCabalMostrar,
                    borderColor: ['#a5c2f7'],
                    backgroundColor: ['rgb(40, 95, 203)'],
                    borderWidth: 2,
                    fill: true,
                    tension: 0.4,
                    // barThickness: 40, 
                },
                {
                    yAxisID: 'y1', 
                    label: 'Clientes Procard',
                    data: clientePorMesProcard,
                    borderColor: ['rgb(1, 168, 86)'],
                    backgroundColor: ['#76f2b4'],
                    borderWidth: 2,
                    fill: true,
                    tension: 0.4,
                    // barThickness: 40, 
                },
                {
                    yAxisID: 'y1', 
                    label: 'Extractos Enviados Procard',
                    data: totalextractoProcardMostrar,
                    borderColor: ['rgb(3, 207, 92)'],
                    backgroundColor: ['rgb(1, 168, 86)'],
                    borderWidth: 2,
                    fill: true,
                    tension: 0.4,
                    // barThickness: 40, 
                }
            ]
        };
        
        this.basicOptions = {
            plugins: {
                datalabels: {
                    anchor: 'center',
                    clamp: true,
                    align: 'end',
                    formatter: (value: any, ctx: any) => {
                        return this.currencyPipe.transform(value, '', '', '0.0-0', 'es-PY');
                    },
                    color: '#000000',
                    font: { size: 11, weight: 'bold' }
                },
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            responsive: true,
            scales: {
                // y: {
                //     position: 'right', display: true, ticks: { fontFamily, color: textColor },
                //     grid: { color: gridLinesColor }
                // },
                y1: {  position: 'left', display: true, ticks: { fontFamily, color: textColor }, grid: { color: gridLinesColor } },
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            },
            maintainAspectRatio: false,
            aspectRatio: 0.9,
            height: 400,
        };
        
    }

    async notificacionAnual() {
        try {
            const resp = await this.homeService.notificacionAnual({
                id_empresa: this.formGroup.value.id_empresa,
                annio: this.formGroup.value.annio
            });
            if (resp.ok) {
                this.notificacionAnuales = resp.resp;   
            }
        } catch (error) {
            this.messageService.add(this.objSession);
            setTimeout(() => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }

    async notificacionDona() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        this.datanotificacion = {
            labels: this.notificationChannels.map((channel) => channel.label),
            datasets: [
                {
                    data: this.notificationChannels.map((channel) => this.getNotificationTotalByType(channel.tipo)),
                    backgroundColor: this.notificationChannels.map((channel) => channel.backgroundColor),
                    hoverBackgroundColor: this.notificationChannels.map((channel) => channel.hoverBackgroundColor),
                    borderColor: this.notificationChannels.map((channel) => channel.borderColor),
                }
            ]
        };

        this.optionsnoti = {
            
            plugins: {
                datalabels: {
                    formatter: (value: any, ctx: any) => {
                        return this.currencyPipe.transform(value, '', '', '0.0-0', 'es-PY');
                    },
                    color: '#FFFFFF',
                    font: {
                        size: 14,
                        weight: 'bold'
                    },
                    anchor: 'end', 
                    align: 'start'
                },
                legend: {
                    labels: {
                        position: 'left',
                        color: '#000000', 
                        usePointStyle: true,
                        font: {
                            weight: 'bold',
                            size: 14,
                        }
                    }
                },
            }
        };
    }

    async notificacionBarra() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = getComputedStyle(document.body).getPropertyValue('--text-color') || 'rgba(0, 0, 0, 0.87)';
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        const gridLinesColor = getComputedStyle(document.body).getPropertyValue('--divider-color') || 'rgba(160, 167, 181, .3)';
        const fontFamily = getComputedStyle(document.body).getPropertyValue('--font-family');
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const mesActual = this.getNotificationMonthLimit();
        const mesesMostrar = [];
        for (let i = 0; i < mesActual; i++) {
            mesesMostrar.push(meses[i]);
        }

        this.basicDataNoti = {
            labels: mesesMostrar,
            datasets: this.notificationChannels.map((channel) => ({
                yAxisID: 'y1',
                label: channel.label,
                data: mesesMostrar.map((_, index) => this.getNotificationTotalByMonth(channel.tipo, index + 1)),
                borderColor: [channel.borderColor],
                backgroundColor: [channel.backgroundColor],
                borderWidth: 2,
                fill: true,
                tension: 0.4,
                barThickness: 28,
            }))
        };
        this.basicOptionsNoti = {
            plugins: {
                datalabels: {
                    anchor: 'center',
                    clamp: true,
                    align: 'end',
                    formatter: (value: any, ctx: any) => {
                        return this.currencyPipe.transform(value, '', '', '0.0-0', 'es-PY');
                    },
                    color: '#000000',
                    font: { size: 11, weight: 'bold' }
                },
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            responsive: true,
            scales: {
                // y: {
                //     position: 'right', display: true, ticks: { fontFamily, color: textColor },
                //     grid: { color: gridLinesColor }
                // },
                y1: {  position: 'left', display: true, ticks: { fontFamily, color: textColor }, grid: { color: gridLinesColor } },
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            },
            maintainAspectRatio: false,
            aspectRatio: 0.9,
            height: 400,
        };
    }

    private getNotificationTotalByType(tipo: number): number {
        return this.notificacionAnuales.reduce((total, notification) => {
            if (notification.tipo === tipo) {
                return total + parseInt(notification.total_enviado);
            }

            return total;
        }, 0);
    }

    private getNotificationTotalByMonth(tipo: number, mes: number): number {
        return this.notificacionAnuales.reduce((total, notification) => {
            if (notification.tipo === tipo && Number(notification.mes) === mes) {
                return total + parseInt(notification.total_enviado);
            }

            return total;
        }, 0);
    }

    private getNotificationMonthLimit(): number {
        const fechaActual = new Date();
        const annioSeleccionado = new Date(this.formGroup.value.annio).getFullYear();
        const annioActual = fechaActual.getFullYear();

        if (annioSeleccionado < annioActual) {
            return 12;
        }

        if (annioSeleccionado === annioActual) {
            return fechaActual.getMonth() + 1;
        }

        return 0;
    }

    private async openNotificationReport(tipo: number) {
        if (!this.informeNotificaciones) {
            return;
        }

        const filtros = this.buildNotificationReportFilters(tipo);

        await this.reporteService.setFiltroStorage(this.informeNotificacionStorageKey, filtros);
        await this.router.navigate([this.prefixPage, 'notificacion', 'reportes', 'informe-notificacion']);
    }

    private buildNotificationReportFilters(tipo: number): Record<string, any> {
        const { fechaDesde, fechaHasta } = this.getNotificationReportDateRange();

        return {
            id_empresa: this.formGroup.value.id_empresa,
            nombre_empresa: this.formGroup.value.nombre_empresa,
            fecha_desde: fechaDesde,
            fecha_hasta: fechaHasta,
            tipo,
        };
    }

    private getNotificationReportDateRange(): { fechaDesde: Date; fechaHasta: Date } {
        const fechaActual = new Date();
        const annioSeleccionado = new Date(this.formGroup.value.annio).getFullYear();
        const fechaDesde = new Date(annioSeleccionado, 0, 1);
        const fechaHasta = annioSeleccionado >= fechaActual.getFullYear()
            ? fechaActual
            : new Date(annioSeleccionado, 11, 31);

        return { fechaDesde, fechaHasta };
    }

}
